// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FKz9","buttons":"Footer_buttons__3lDBf"};